export enum TaxType {
	ROT = "ROT",
	RUT = "RUT",
}
